import { createTheme } from '@mui/material/styles';

// Same layout and colours teams already know (MUI blue); the refresh is in surfaces, spacing and type only.
export const theme = createTheme({
	palette: {
		background: {
			default: '#f4f6fa',
		},
	},
	shape: {
		borderRadius: 8,
	},
	typography: {
		button: {
			textTransform: 'none',
			fontWeight: 600,
		},
	},
	components: {
		MuiAppBar: {
			defaultProps: {
				elevation: 1,
			},
		},
		MuiContainer: {
			defaultProps: {
				disableGutters: true,
			},
			styleOverrides: {
				root: {
					marginLeft: 0,
					marginRight: 0,
				},
			},
		},
		MuiButton: {
			defaultProps: {
				disableElevation: true,
			},
		},
		MuiListItemButton: {
			styleOverrides: {
				root: ({ theme }) => ({
					'&.Mui-selected': {
						borderRight: `3px solid ${theme.palette.primary.main}`,
					},
				}),
			},
		},
		MuiDataGrid: {
			defaultProps: {
				localeText: {
					noRowsLabel: 'No data to show',
				},
			},
			styleOverrides: {
				root: ({ theme }) => ({
					backgroundColor: theme.palette.background.paper,
					'& .MuiDataGrid-columnHeader': {
						backgroundColor: theme.palette.grey[100],
					},
					'& .MuiDataGrid-cell': {
						display: 'flex',
						alignItems: 'center',
					},
					'& .MuiDataGrid-row:hover': {
						backgroundColor: theme.palette.action.hover,
					},
					'& .MuiDataGrid-columnHeaderTitle': {
						fontWeight: 600,
					},
				}),
				cellContent: {
					whiteSpace: 'pre-line',
					wordBreak: 'break-all',
					textAlign: 'left',
				},
			},
		},
	},
});
